import React from 'react';
import styles from "../../styles/components/demandFilters.module.scss";

export default function index(props) {

     function camelize(str) {
       return str
         .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
           return index === 0 ? word.toLowerCase() : word.toUpperCase();
         })
         .replace(/\s+/g, "");
     }


const initialFilterButtonState = {0 : false, 1 : false, 2 : false, 3 : false}    
const [filterButtonsState, setFilterButtonState] = React.useState({...initialFilterButtonState, 0:true})
const [filterState, setFilterState] = React.useState({})

const radioChange = (e) => {
//console.log(filterState, "filterState")
  setFilterState({...filterState, [e.target.name] : e.target.value})
}

const filterButtonClicked = (index) => {
    setFilterButtonState({...initialFilterButtonState, [index] : true})
}


const applyFilter = () => {
    props.setState(filterState)
    props.setfilterActive(false)
}
  //console.log(props.filterMobileData);  
    return (
      <div className={styles.mobileFiltersWrapper}>
        <div className={styles.head}>
          <p className={styles.title}>Filters</p>
          <p className={styles.clearFilters} onClick = {() => {setFilterState({})}}>Clear All Filters</p>
        </div>
        <div className={styles.body}>
          <div className={styles.left}>
            <ul>
              {props.filterMobileData.map((item, index) => (
                <li
                  className={filterButtonsState[index] ? styles.active : null}
                  onClick={() => filterButtonClicked(index)}
                >
                  {item.field_label}
                </li>
              ))}
              {/* <li >Cluster</li>
                       <li>Area <sup>*</sup></li>
                       <li className={styles.active}>Target Pitch</li>
                       <li>EL<sup>*</sup></li> */}
            </ul>
          </div>
          <div className={styles.right}>
            <ul>
              {props.filterMobileData.map((item, index) =>
                filterButtonsState[index] ? (
                  <ul onChange = {radioChange}>
                    {item.field_options.map((optionItem, optionIndex) => (
                      <li>
                        {/* <label className={styles.list_Checkbox_container}>
                          <span className={styles.lableHead}>{optionItem}</span>
                          <input type="radio" />
                          <span className={styles.radioCheckmark}></span>
                        </label> */}
                        <label className={styles.radioWrapper}>
                          <input
                            type="radio"
                            className={styles.radioBox}
                             value={optionItem}
                             name={camelize(item.field_label)}
                             checked={
                               optionItem == filterState[camelize(item.field_label)] ? true : false
                             }
                          />
                          <span className={styles.radioCheckmark}></span>
                          <span className={styles.subLabel}>{optionItem}</span>
                        </label>
                      </li>
                    ))}
                  </ul>
                ) : null
              )}
             
            </ul>
          </div>
        </div>
        <div className={styles.foot}>
          <span className={styles.cancelBtn} onClick = {() => {props.setFilterActive(false)}}>Cancel</span>
          <span className={styles.applyBtn} onClick = {applyFilter}>Apply</span>
        </div>
      </div>
    );
}
